var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import IconChevronRight from "./icons/IconChevronRight";
import IconChevronLeft from "./icons/IconChevronLeft";
import IconUser from "./icons/IconUser";
import IconUsers from "./icons/IconUsers";
import IconFilter from "./icons/IconFilter";
import IconActivities from "./icons/IconActivities";
import IconBirthday from "./icons/IconBirthday";
import IconBookmark from "./icons/IconBookmark";
import IconBookmarkOutline from "./icons/IconBookmarkOutline";
import IconEducation from "./icons/IconEducation";
import IconChat from "./icons/IconChat";
import IconInfoBrain from "./icons/IconInfoBrain";
import IconCog from "./icons/IconCog";
import IconInfo from "./icons/IconInfo";
import IconFeed from "./icons/IconFeed";
import IconHome from "./icons/IconHome";
import IconStarFull from "./icons/IconStarFull";
import IconStarHalf from "./icons/IconStarHalf";
import IconStarEmpty from "./icons/IconStarEmpty";
import IconComment from "./icons/IconComment";
import IconPlaylist from "./icons/IconPlaylist";
import IconSlideshow from "./icons/IconSlideshow";
import IconFriends from "./icons/IconFriends";
import IconAdd from "./icons/IconAdd";
import IconAddCircle from "./icons/IconAddCircle";
import IconTimes from "./icons/IconTimes";
import IconTimesCircle from "./icons/IconTimesCircle";
import IconCheck from "./icons/IconCheck";
import IconCheckSquare from "./icons/IconCheckSquare";
import IconThumbUp from "./icons/IconThumbUp";
import IconThumbDown from "./icons/IconThumbDown";
import IconSearch from "./icons/IconSearch";
import IconSearchClose from "./icons/IconSearchClose";
import IconReload from "./icons/IconReload";
import IconAudio from "./icons/IconAudio";
import IconTrending from "./icons/IconTrending";
import IconMore from "./icons/IconMore";
import IconEdit from "./icons/IconEdit";
import IconEmpty from "./icons/IconEmpty";
import IconDelete from "./icons/IconDelete";
import IconGame from "./icons/IconGame";
import IconResume from "./icons/IconResume";
import IconStats from "./icons/IconStats";
import IconVideoPlayer from "./icons/IconVideoPlayer";
import IconRocket from "./icons/IconRocket";
import IconShapes from "./icons/IconShapes";
import IconLaw from "./icons/IconLaw";
import IconDice from "./icons/IconDice";
import IconContentAggregation from "./icons/IconContentAggregation";
import IconExclamationTriangle from "./icons/IconExclamationTriangle";
import IconUploadCloud from "./icons/IconUploadCloud";
import IconDownloadCloud from "./icons/IconDownloadCloud";
import IconBox from "./icons/IconBox";
import IconSave from "./icons/IconSave";
import IconDownload from "./icons/IconDownload";
import IconUpload from "./icons/IconUpload";
import IconCopy from "./icons/IconCopy";
import IconSend from "./icons/IconSend";
import IconChevronUp from "./icons/IconChevronUp";
import IconChevronDown from "./icons/IconChevronDown";
import IconEyeOpen from "./icons/IconEyeOpen";
import IconEyeClose from "./icons/IconEyeClose";
import IconEyeCheck from "./icons/IconEyeCheck";
import IconEyeTimes from "./icons/IconEyeTimes";
import IconCalendar from "./icons/IconCalendar";
import IconLock from "./icons/IconLock";
import IconUnlock from "./icons/IconUnlock";
import IconPaperclip from "./icons/IconPaperclip";
import IconAward from "./icons/IconAward";
import IconExclamationCircle from "./icons/IconExclamationCircle";
import IconPencil from "./icons/IconPencil";
import IconTag from "./icons/IconTag";
import IconChartPie from "./icons/IconChartPie";
import IconChartBar from "./icons/IconChartBar";
import IconCamera from "./icons/IconCamera";
import IconCameraTimes from "./icons/IconCameraTimes";
import IconClipboard from "./icons/IconClipboard";
import IconClock from "./icons/IconClock";
import IconColumn1 from "./icons/IconColumn1";
import IconColumn2 from "./icons/IconColumn2";
import IconColumn3 from "./icons/IconColumn3";
import IconLink from "./icons/IconLink";
import IconExternalLink from "./icons/IconExternalLink";
import IconBell from "./icons/IconBell";
import IconFolder from "./icons/IconFolder";
import IconFolderAdd from "./icons/IconFolderAdd";
import IconFolderMinus from "./icons/IconFolderMinus";
import IconGlobe from "./icons/IconGlobe";
import IconHeart from "./icons/IconHeart";
import IconHash from "./icons/IconHash";
import IconFlag from "./icons/IconFlag";
import IconHelpCircle from "./icons/IconHelpCircle";
import IconImage from "./icons/IconImage";
import IconImages from "./icons/IconImages";
import IconKey from "./icons/IconKey";
import IconMail from "./icons/IconMail";
import IconLocation from "./icons/IconLocation";
import IconMaximize from "./icons/IconMaximize";
import IconMinimize from "./icons/IconMinimize";
import IconMicOn from "./icons/IconMicOn";
import IconMicOff from "./icons/IconMicOff";
import IconAddSquare from "./icons/IconAddSquare";
import IconMinusCircle from "./icons/IconMinusCircle";
import IconMinusSquare from "./icons/IconMinusSquare";
import IconMinus from "./icons/IconMinus";
import IconMonitor from "./icons/IconMonitor";
import IconPercent from "./icons/IconPercent";
import IconTurnedOn from "./icons/IconTurnedOn";
import IconTurnedOff from "./icons/IconTurnedOff";
import IconUndo from "./icons/IconUndo";
import IconRedo from "./icons/IconRedo";
import IconDeleteEmpty from "./icons/IconDeleteEmpty";
import IconAdmin from "./icons/IconAdmin";
import IconUserCheck from "./icons/IconUserCheck";
import IconUserTimes from "./icons/IconUserTimes";
import IconUserAdd from "./icons/IconUserAdd";
import IconUserMinus from "./icons/IconUserMinus";
import IconCircle from "./icons/IconCircle";
import IconCircleDot from "./icons/IconCircleDot";
import IconQuote from "./icons/IconQuote";
import IconMobile from "./icons/IconMobile";
import IconEditClose from "./icons/IconEditClose";
import IconAsking from "./icons/IconAsking";
import IconLogout from "./icons/IconLogout";
import IconLogin from "./icons/IconLogin";
import IconBulb from "./icons/IconBulb";
import IconExcite from "./icons/IconExcite";
import IconChevronRightDouble from "./icons/IconChevronRightDouble";
import IconChevronLeftRight from "./icons/IconChevronLeftRight";
import IconChevronRightLeft from "./icons/IconChevronRightLeft";
import IconChevronUpDown from "./icons/IconChevronUpDown";
import IconChevronLeftDouble from "./icons/IconChevronLeftDouble";
import IconChevronUpDouble from "./icons/IconChevronUpDouble";
import IconChevronDownDouble from "./icons/IconChevronDownDouble";
import IconEmoSmile from "./icons/IconEmoSmile";
import IconEmoFrown from "./icons/IconEmoFrown";
import IconEmoNeutral from "./icons/IconEmoNeutral";
import IconTablet from "./icons/IconTablet";
import IconUploadAudio from "./icons/IconUploadAudio";
import IconUploadVideo from "./icons/IconUploadVideo";
import IconUploadImage from "./icons/IconUploadImage";
import IconCheckCircle from "./icons/IconCheckCircle";
import IconTimesSquare from "./icons/IconTimesSquare";
import IconRotateLeft from "./icons/IconRotateLeft";
import IconRotateRight from "./icons/IconRotateRight";
import IconRotateUp from "./icons/IconRotateUp";
import IconRotateDown from "./icons/IconRotateDown";
import IconZoomIn from "./icons/IconZoomIn";
import IconZoomOut from "./icons/IconZoomOut";
import IconTable from "./icons/IconTable";
import IconGridV from "./icons/IconGridV";
import IconGridH from "./icons/IconGridH";
import IconMirrorV from "./icons/IconMirrorV";
import IconMirrorH from "./icons/IconMirrorH";
import IconImageEffects from "./icons/IconImageEffects";
import IconBook from "./icons/IconBook";
import IconCrop from "./icons/IconCrop";
import IconArticleCheck from "./icons/IconArticleCheck";
import IconArticleTimes from "./icons/IconArticleTimes";
import IconEditTableTop from "./icons/IconEditTableTop";
import IconEditTableBottom from "./icons/IconEditTableBottom";
import IconEditTableLeft from "./icons/IconEditTableLeft";
import IconEditTableRight from "./icons/IconEditTableRight";
import IconMerge from "./icons/IconMerge";
import IconUnmerge from "./icons/IconUnmerge";
import IconCheckTimes from "./icons/IconCheckTimes";
import IconPackage from "./icons/IconPackage";
import IconExpand from "./icons/IconExpand";
import IconDecrease from "./icons/IconDecrease";
import IconLanguage from "./icons/IconLanguage";
import IconBomb from "./icons/IconBomb";
import styled from "styled-components";
import IconAddAbove from "./icons/IconAddAbove";
import IconAddRight from "./icons/IconAddRight";
import IconAddBelow from "./icons/IconAddBelow";
import IconAddLeft from "./icons/IconAddLeft";
import IconDeleteRow from "./icons/IconDeleteRow";
import IconDeleteColumn from "./icons/IconDeleteColumn";
import IconHotspot from "./icons/IconHotspot";
import IconUserLogout from "./icons/IconUserLogout";
import IconQuestionmark from "./icons/IconQuestionmark";
import IconQuestionmarkCircle from "./icons/IconQuestionmarkCircle";
import IconBranchTopRight from "./icons/IconBranchTopRight";
import IconWiki from "./icons/IconWiki";
import { getColor } from "../helpers/ColorHelpers";
export var imgIconDefs = {
    "redo": IconRedo,
    "undo": IconUndo,
    "turned off": IconTurnedOff,
    "turned on": IconTurnedOn,
    "percent": IconPercent,
    "monitor": IconMonitor,
    "tablet": IconTablet,
    "mobile": IconMobile,
    "mic on": IconMicOn,
    "mic off": IconMicOff,
    "minimize": IconMinimize,
    "maximize": IconMaximize,
    "location": IconLocation,
    "mail": IconMail,
    "key": IconKey,
    "help": IconHelpCircle,
    "asking": IconAsking,
    "globe": IconGlobe,
    "heart": IconHeart,
    "hashtag": IconHash,
    "flag": IconFlag,
    "folder": IconFolder,
    "folder plus": IconFolderAdd,
    "folder minus": IconFolderMinus,
    "bell": IconBell,
    "link": IconLink,
    "login": IconLogin,
    "logout": IconLogout,
    "logout user": IconUserLogout,
    "link external": IconExternalLink,
    "clock": IconClock,
    "clipboard": IconClipboard,
    "camera": IconCamera,
    "camera close": IconCameraTimes,
    "chart bar": IconChartBar,
    "chart pie": IconChartPie,
    "tag": IconTag,
    "pencil": IconPencil,
    "exclamation circle": IconExclamationCircle,
    "exclamation triangle": IconExclamationTriangle,
    "award": IconAward,
    "chevron up": IconChevronUp,
    "chevron right": IconChevronRight,
    "chevron down": IconChevronDown,
    "chevron left": IconChevronLeft,
    "chevron left double": IconChevronLeftDouble,
    "chevron right double": IconChevronRightDouble,
    "chevron up double": IconChevronUpDouble,
    "chevron down double": IconChevronDownDouble,
    "chevron left right": IconChevronLeftRight,
    "chevron right left": IconChevronRightLeft,
    "chevron up down": IconChevronUpDown,
    "user": IconUser,
    "users": IconUsers,
    "user minus": IconUserMinus,
    "user plus": IconUserAdd,
    "user times": IconUserTimes,
    "user check": IconUserCheck,
    "admin": IconAdmin,
    "filter": IconFilter,
    "activities": IconActivities,
    "birthday": IconBirthday,
    "bookmark": IconBookmark,
    "bookmark outline": IconBookmarkOutline,
    "education": IconEducation,
    "chat": IconChat,
    "info brain": IconInfoBrain,
    "cog": IconCog,
    "feed": IconFeed,
    "info": IconInfo,
    "home": IconHome,
    "star full": IconStarFull,
    "star half": IconStarHalf,
    "star empty": IconStarEmpty,
    "comment": IconComment,
    "playlist": IconPlaylist,
    "column full": IconColumn1,
    "column halves": IconColumn2,
    "column thirds": IconColumn3,
    "slideshow": IconSlideshow,
    "friends": IconFriends,
    "add": IconAdd,
    "add circle": IconAddCircle,
    "add square": IconAddSquare,
    "minus": IconMinus,
    "minus circle": IconMinusCircle,
    "minus square": IconMinusSquare,
    "times": IconTimes,
    "times circle": IconTimesCircle,
    "times square": IconTimesSquare,
    "check": IconCheck,
    "check square": IconCheckSquare,
    "check circle": IconCheckCircle,
    "thumb up": IconThumbUp,
    "thumb down": IconThumbDown,
    "search": IconSearch,
    "search close": IconSearchClose,
    "reload": IconReload,
    "trending": IconTrending,
    "more": IconMore,
    "edit": IconEdit,
    "edit close": IconEditClose,
    "empty": IconEmpty,
    "delete": IconDelete,
    "delete empty": IconDeleteEmpty,
    "game": IconGame,
    "resume": IconResume,
    "stats": IconStats,
    "video player": IconVideoPlayer,
    "audio": IconAudio,
    "image": IconImage,
    "images": IconImages,
    "rocket": IconRocket,
    "shapes": IconShapes,
    "law": IconLaw,
    "dice": IconDice,
    "content aggregation": IconContentAggregation,
    "box": IconBox,
    "save": IconSave,
    "download": IconDownload,
    "download cloud": IconDownloadCloud,
    "upload": IconUpload,
    "upload cloud": IconUploadCloud,
    "upload image": IconUploadImage,
    "upload video": IconUploadVideo,
    "upload audio": IconUploadAudio,
    "copy": IconCopy,
    "send": IconSend,
    "eye open": IconEyeOpen,
    "eye close": IconEyeClose,
    "eye check": IconEyeCheck,
    "eye times": IconEyeTimes,
    "calendar": IconCalendar,
    "unlock": IconUnlock,
    "lock": IconLock,
    "paperclip": IconPaperclip,
    "square": IconColumn1,
    "circle": IconCircle,
    "circle dot": IconCircleDot,
    "quote": IconQuote,
    "excite": IconExcite,
    "smiley smile": IconEmoSmile,
    "smiley frown": IconEmoFrown,
    "smiley neutral": IconEmoNeutral,
    "bulb": IconBulb,
    "rotate left": IconRotateLeft,
    "rotate right": IconRotateRight,
    "rotate up": IconRotateUp,
    "rotate down": IconRotateDown,
    "table": IconTable,
    "zoom in": IconZoomIn,
    "zoom out": IconZoomOut,
    "grid vertical": IconGridV,
    "grid horizontal": IconGridH,
    "mirror vertical": IconMirrorV,
    "mirror horizontal": IconMirrorH,
    "image effects": IconImageEffects,
    "book": IconBook,
    "article check": IconArticleCheck,
    "article times": IconArticleTimes,
    "edit table top": IconEditTableTop,
    "edit table bottom": IconEditTableBottom,
    "edit table left": IconEditTableLeft,
    "edit table right": IconEditTableRight,
    "merge": IconMerge,
    "unmerge": IconUnmerge,
    "check times": IconCheckTimes,
    "add above": IconAddAbove,
    "add right": IconAddRight,
    "add below": IconAddBelow,
    "add left": IconAddLeft,
    "delete row": IconDeleteRow,
    "delete column": IconDeleteColumn,
    "crop": IconCrop,
    "expand": IconExpand,
    "decrease": IconDecrease,
    "package": IconPackage,
    "bomb": IconBomb,
    "language": IconLanguage,
    "hotspot": IconHotspot,
    "questionark": IconQuestionmark,
    "questionark circle": IconQuestionmarkCircle,
    "wiki": IconWiki,
    "branch top right": IconBranchTopRight
};
var FillColor = styled.span(function (p) { return "\n    svg{\n        fill: " + getColor(p, p.filledWithColor) + ";\n    }\n"; });
var Icon = React.memo(function (props) {
    var _a;
    var name = props.name, p = __rest(props, ["name"]);
    var I = imgIconDefs[name];
    if (I)
        return React.createElement(FillColor, { filledWithColor: (_a = props.filledWithColor) !== null && _a !== void 0 ? _a : "none" },
            React.createElement(I, __assign({}, p)));
    return null;
});
export default Icon;
//# sourceMappingURL=Icon.js.map